import type { SubmitJoinApplicationServiceRequest } from '@musinsa/services-curator';

export const FUNNEL_STEPS = {
  SNS: 1,
  ACCOUNT: 2,
} as const;

export type FunnelStep = 1 | 2;

export interface FunnelProps {
  formValues: SubmitJoinApplicationServiceRequest;
  onUpdate: (values: Partial<SubmitJoinApplicationServiceRequest>) => void;
  onNext: () => void;
  onPrev: () => void;
}
